/* =========================================================
   ZOHO DEFAULT FUNCTION (DO NOT MODIFY)
   ========================================================= */
function zf_ValidateAndSubmit() {
    if (zf_CheckMandatory()) {
        if (zf_ValidCheck()) {
            if (
                typeof isSalesIQIntegrationEnabled !== "undefined" &&
                isSalesIQIntegrationEnabled
            ) {
                zf_addDataToSalesIQ();
            }
            return true;
        }
        return false;
    }
    return false;
}

/* =========================================================
   PHONE RULES (COUNTRY-WISE)
   ========================================================= */
var phoneRules = {
    "+91": { min: 10, max: 10, regex: /^[6-9][0-9]{9}$/ }, // India
    "+1": { min: 10, max: 10, regex: /^[2-9][0-9]{9}$/ }, // US / Canada
    "+44": { min: 10, max: 11, regex: /^[0-9]{10,11}$/ }, // UK
    "+971": { min: 9, max: 9, regex: /^[0-9]{9}$/ },    // UAE
    "+61": { min: 9, max: 9, regex: /^[0-9]{9}$/ },    // Australia
    "default": { min: 6, max: 15, regex: /^[0-9]{6,15}$/ }
};

/* =========================================================
   CUSTOM VALIDATION + UI + DELAYED SUBMIT
   ========================================================= */
(function () {

    var form = document.getElementById("form");
    if (!form) return;

    var phoneInput = document.querySelector('input[name="PhoneNumber_countrycode"]');
    var countrySelect = document.getElementById("PhoneCountryCode");

    var alreadySubmitted = false;

    /* =====================================================
       PHONE INPUT FORMAT & LENGTH CONTROL
       ===================================================== */
    phoneInput.addEventListener("input", function () {
        var rule = phoneRules[countrySelect.value] || phoneRules.default;

        // Allow digits only
        this.value = this.value.replace(/\D/g, "");

        // Restrict length
        if (this.value.length > rule.max) {
            this.value = this.value.slice(0, rule.max);
        }

        // Auto clear error if valid
        if (rule.regex.test(this.value.trim())) {
            hideError("PhoneNumber_error", this);
        }
    });

    /* =====================================================
       FORM SUBMIT HANDLER
       ===================================================== */
    form.addEventListener(
        "submit",
        function (e) {

            if (alreadySubmitted) return;

            var nameField = document.querySelector('input[name="SingleLine"]');
            var qtyField = document.querySelector('input[name="Number"]');
            var stateField = document.querySelector('select[name="Dropdown1"]');

            var name = nameField.value.trim();
            var phone = phoneInput.value.trim();
            var qty = qtyField.value.trim();
            var state = stateField.value;
            var rule = phoneRules[countrySelect.value] || phoneRules.default;

            /* ---------------- NAME ---------------- */
            if (name.length < 2) {
                e.preventDefault();
                showError("SingleLine_error", "Please enter full name", nameField);
                return;
            }
            hideError("SingleLine_error", nameField);

            /* ---------------- PHONE ---------------- */
            if (!rule.regex.test(phone)) {
                e.preventDefault();
                showError(
                    "PhoneNumber_error",
                    "Invalid phone number for selected country",
                    phoneInput
                );
                return;
            }
            hideError("PhoneNumber_error", phoneInput);

            /* ---------------- QUANTITY ---------------- */
            if (
                qty === "" ||
                isNaN(qty) ||
                Number(qty) < 1 ||
                Number(qty) > 100
            ) {
                e.preventDefault();
                showError(
                    "Number_error",
                    "Quantity must be between 1 and 100",
                    qtyField
                );
                return;
            }
            hideError("Number_error", qtyField);

            /* ---------------- STATE ---------------- */
            if (state === "-Select-") {
                e.preventDefault();
                showError("Dropdown1_error", "Please select your state", stateField);
                return;
            }
            hideError("Dropdown1_error", stateField);

            /* ---------------- ALL VALID ---------------- */
            e.preventDefault();
            alreadySubmitted = true;

            // Stay on same page
            var redirectField = document.querySelector('input[name="zf_redirect_url"]');
            if (redirectField) {
                redirectField.value = window.location.href;
            }

            // Show success UI
            var formWrap = document.querySelector(".zf-templateWrapper");
            var thankYou = document.getElementById("thank-you-container");

            if (formWrap) formWrap.style.display = "none";
            if (thankYou) {
                thankYou.style.display = "block";
                thankYou.scrollIntoView({ behavior: "smooth" });
            }

            // Submit to Zoho after 5 seconds
            setTimeout(function () {
                form.submit();
            }, 5000);

        },
        true // CAPTURE PHASE (REQUIRED FOR ZOHO)
    );

    /* =====================================================
       REAL-TIME ERROR CLEARING
       ===================================================== */

    document.querySelector('input[name="SingleLine"]')
        ?.addEventListener("input", function () {
            if (this.value.trim().length >= 2) {
                hideError("SingleLine_error", this);
            }
        });

    document.querySelector('input[name="Number"]')
        ?.addEventListener("input", function () {
            if (this.value !== "" && !isNaN(this.value) && Number(this.value) > 0) {
                hideError("Number_error", this);
            }
        });

    document.querySelector('select[name="Dropdown1"]')
        ?.addEventListener("change", function () {
            if (this.value !== "-Select-") {
                hideError("Dropdown1_error", this);
            }
        });

    /* =====================================================
       HELPER FUNCTIONS
       ===================================================== */
    function showError(id, msg, field) {
        var el = document.getElementById(id);
        if (el) {
            el.innerText = msg;
            el.style.display = "block";
        }
        if (field) {
            field.classList.add("error-field");
            field.focus();
        }
    }

    function hideError(id, field) {
        var el = document.getElementById(id);
        if (el) el.style.display = "none";

        if (field) {
            field.classList.remove("error-field");
        }
    }

})();
